<template>
  <div v-if="show" class="tips" :class="[tipClass,placementClass]">
    <slot></slot>
    <i @click.stop="closeTips" class="el-icon-close close-icon"></i>
  </div>
</template>

<script>
export default {
  props: {
    tipClass: {
      type: String
    },
    duration: {
      type: Number,
      default: 6000
    },
    placement: {
      type: String,
      default: 'top-start',
    }
  },
  computed: {
    placementClass () {
      if (this.allowTipClass.includes(this.placement)) {
        return `${this.placement.split('-')[0]}-tips ${this.placement}`
      } else {
        return 'top-tips top-start';
      }
    }
  },
  data () {
    return {
      show: true,
      allowTipClass: ['top-start', 'top-center', 'top-end', 'right-start', 'right-center', 'right-end', 'bottom-start', 'bottom-center', 'bottom-end', 'left-start', 'left-center', 'left-end']
    }
  },
  mounted () {
    this.closeTipsAsync();
  },
  methods: {
    closeTipsAsync () {
      setTimeout(() => {
        this.show = false;
        this.$emit('tips-closed')
      }, this.duration);
    },
    closeTips () {
      this.show = false;
      this.$emit('tips-closed')
    }
  }
}
</script>

<style lang="less" scoped>
@tips-color: #5862ab70;
.tips {
  position: absolute;
  padding: 0 25px;
  height: 35px;
  line-height: 35px;
  background: @tips-color;
  border-radius: 5px;
  animation: infinite-bounce 1s infinite alternate;
  color: #fff;
  z-index: 1;
  &.top-tips {
    &:after {
      top: -16px;
      border-color: transparent transparent @tips-color transparent;
    }
    &.top-start {
      &:after {
        left: 20%;
      }
    }
    &.top-center {
      &:after {
        left: 50%;
        transform: translateX(-50%);
      }
    }
    &.top-end {
      &:after {
        right: 20%;
      }
    }
  }
  &.bottom-tips {
    &:after {
      bottom: -16px;
      border-color: @tips-color transparent transparent transparent;
    }
    &.bottom-start {
      &:after {
        left: 20%;
      }
    }
    &.bottom-center {
      &:after {
        left: 50%;
        transform: translateX(-50%);
      }
    }
    &.bottom-end {
      &:after {
        right: 20%;
      }
    }
  }
  &.left-tips {
    &:after {
      left: -16px;
      border-color: transparent @tips-color transparent transparent;
    }
    &.left-start {
      &:after {
        top: 20%;
      }
    }
    &.left-center {
      &:after {
        top: 50%;
        transform: translateY(-50%);
      }
    }
    &.left-end {
      &:after {
        bottom: 20%;
      }
    }
  }
  &.right-tips {
    &:after {
      right: -16px;
      border-color: transparent transparent transparent @tips-color;
    }
    &.right-start {
      &:after {
        top: 20%;
      }
    }
    &.right-center {
      &:after {
        top: 50%;
        transform: translateY(-50%);
      }
    }
    &.right-end {
      &:after {
        bottom: 20%;
      }
    }
  }
  &:after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    font-size: 0;
    border: solid 8px;
  }

  .close-icon {
    position: absolute;
    top: 50%;
    right: 5px;
    font-size: 16px;
    transform: translateY(-50%);
    cursor: pointer;
    &:hover {
      font-weight: 700;
    }
  }
  @keyframes infinite-bounce {
    0% {
      transform: translateY(10%);
    }
    100% {
      transform: translateY(-10%);
    }
  }
}
</style>

